import React from "react";

const InfoPage = () => (
  <div />
)

export default InfoPage;
